import {
  getTaxTypePlaceholder,
  getTaxTypes,
  normalizeDecimalValue,
} from '../../helpers';

export const getDiscountTypes = (t) => {
  return [
    {
      value: 'amount',
      label: t('createInvoice.discount_dialog.discount_amount'),
      id: 'amount',
    },
    {
      value: 'subject_amount',
      label: t('createInvoice.amount_subject_to_discount_radio_label'),
      id: 'subject_amount',
    },
  ];
};

export const DISCOUNT_LINE_ITEMS_COLUMNS = ({ currency }) => [
  {
    key: 'discountAmount',
    field: 'discountAmount',
    label: 'createInvoice.discount_dialog.table.discount_amount',
    body: (lang, value) =>
      value ? `${Number(value).toFixed(3)} ${currency}` : '-',
    type: 'text',
  },
  {
    key: 'amountSubjectToDiscount',
    field: 'amountSubjectToDiscount',
    label: 'createInvoice.discount_dialog.table.amount_subject_to_discount',
    body: (lang, value) =>
      value ? `${Number(value).toFixed(3)} ${currency}` : '-',
    type: 'text',
  },
  {
    key: 'rate',
    field: 'rate',
    label: 'createInvoice.discount_dialog.table.discount_rate',
    body: (lang, value) => (value ? `${value}%` : '-'),
    type: 'text',
    headerTooltip: 'tooltips.discountRate',
  },
  {
    key: 'discountVatRateType',
    field: 'discountVatRateType',
    label: 'createInvoice.discount_dialog.table.discount_vat_rate',
    type: 'select',
    body: (lang, value) =>
      getTaxTypes(lang).find((type) => type.value === value)?.label || value,
  },
];

export const getDiscountFieldProps = (lang, t, setFieldValue) => ({
  discountAmount: {
    componentProps: {
      placeholder: t('createInvoice.discount_amount_placeholder'),
      type: 'text',
      inputMode: 'decimal',
      maxlength: 15,
      onChange: (e) => {
        setFieldValue(normalizeDecimalValue(e.target.value));
      },
    },
  },
  amountSubjectToDiscount: {
    componentProps: {
      placeholder: t('createInvoice.amount_subject_to_discount_placeholder'),
      type: 'text',
      inputMode: 'decimal',
      maxlength: 15,
      onChange: (e) => {
        setFieldValue(normalizeDecimalValue(e.target.value));
      },
    },
  },
  rate: {
    componentProps: {
      placeholder: t('createInvoice.discount_rate_placeholder'),
      type: 'text',
      inputMode: 'decimal',
      maxlength: 6,
      showPercentageAdornment: true,
      onChange: (e) => {
        setFieldValue(normalizeDecimalValue(e.target.value, 2));
      },
    },
  },
  discountVatRateType: {
    componentProps: {
      options: getTaxTypes(lang),
      onChange: (e) => {
        if (e === getTaxTypePlaceholder(lang)) {
          setFieldValue('');
        } else {
          setFieldValue(e);
        }
      },
    },
  },
});
